<script lang="ts">
  interface Props {
    options: { label: string; value: string | null }[];
    value: string | null;
    onchange?: (value: string | null) => void;
    id?: string;
    disabled?: boolean;
    variant?: "default" | "transparent";
    class?: string;
  }

  let {
    options,
    value = $bindable(),
    onchange,
    id,
    disabled = false,
    variant = "default",
    class: className,
  }: Props = $props();
</script>

{#if !disabled}
  <select
    bind:value
    onchange={() => onchange?.(value)}
    data-variant={variant}
    {id}
    {disabled}
    class={["max-w-full", className]}
  >
    {#each options as option}
      <option value={option.value} selected={option.value === value}>
        {option.label}
      </option>
    {/each}
  </select>
{:else}
  <span class={["disabled-span pr-4", className]}
    >{options.find((o) => o.value === value)?.label}</span
  >
{/if}

<style lang="postcss">
  :where(select):where([data-variant]),
  .disabled-span {
    @apply py-0 pl-4 rounded-[3px] border text-lg text-almanac-lime-green border-almanac-lime-green/50 bg-almanac-lime-green/5 font-semibold inline-block;
    @apply focus:border-almanac-lime-green/40 focus:outline-none focus:ring-2 focus:ring-almanac-lime-green/40;
  }

  :where(select):where([data-variant="transparent"]) {
    @apply bg-transparent border-almanac-lime-green/20 text-almanac-dark-green font-normal;
  }

  :where(select):where(:not([class])),
  :where(select):where(:not([class]))::picker-icon {
    appearance: base-select;
  }
</style>
